import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <>
            <footer className="pc-footer">
                <div className="footer-wrapper container-fluid">
                    <div className="row">
                        <div className="col my-1">
                            <p className="m-0">
                                All Rights Reserved by Team{" "}
                                <Link to="/">
                                    Sales Tracker
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}

export default Footer